<div class="container-fluid">
    <div class="pb-wrapper bg-white p-4">

           <button class="btn btn-primary" style="float: right;">+ Add Branches</button>



        <div class="row">
            <div class="col-xl-12 col-lg-12">
                <div class="all-leads mt-5">
                    <div class="card shadow mb-4">
                        <div class="card-body">
                            <h3 class="d-inline-block mr-3 mb-0" style="color: rgb(177, 128, 128);">Branches</h3>
                            <div class="table-responsive">
                                <table class="table table-hover agent-table">
                                    <thead>
                                        <tr>
                                            <th>S.NO</th>
                                            <th>Branch</th>
                                            <th>Contact Person</th>
                                            <th>Mobile Number</th>
                                            <th>Email Id</th>
                                            <th>Date Added</th>
                                            <th>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of filteredMembers">
                                            <td><input type="checkbox"></td>
                                            <td>{{ item.Branch }}</td>
                                            <td>{{ item.ContactPerson }}</td>
                                            <td>{{ item.MobileNumber}}</td>
                                            <td>{{ item.EmailId }}</td>
                                            <td>{{ item.DateAdded }}</td>
                                            <td>{{ item.Remarks }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>